import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { IEssayList } from '../../../core/models/essay';

interface EssayListState {
  essays: IEssayList[];
  setEssays: (essays: IEssayList[]) => void;
  resetEssays: () => void;
}

export const useEssayListStore = create<EssayListState>()(
  persist(
    (set) => ({
      essays: [],
      setEssays: (essays: IEssayList[]) => set({ essays }),
      resetEssays: () => set({ 
        essays: [], 
      })
    }),
    { name: 'essay-myessays' }
  )
);